// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IBo7-","label":"styles_label__GwjdO"};